import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  transitionToInValidate?: boolean;
}

export const useSendBatchRiskAnalysisReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, transitionToInValidate = false }: HookProps) => {
      if (transitionToInValidate) {
        const transitionResult = await apiClient.batchesWorkflow.transitionToInvalidate.mutation({ params: { id: batchId } });
        if (transitionResult.status !== 200) throw transitionResult.body;
      }

      const result = await apiClient.batchesReports.sendRiskAnalysisReport.mutation({ body: { batchId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['batch', variables.batchId, 'getUserReports'] });
      toast.success('Successfully sent the batch risk analysis report!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error sending the batch risk analysis report!');
    },
  });
};
